import {Component , OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {GenderTypeDialogComponent} from './setting-form/setting-form.component';
import {GenderFuncService} from '../../../../core/services/genderFunc.service';

@Component({
    selector: 'gender-type',
    templateUrl: './genderType.component.html',
    styleUrls: ['./genderType.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class GenderTypeComponent implements OnInit {
  genderTypes: any = [];
  displayedColumns = [ 'name', 'defaultType', 'enable', 'isChild', 'isAdult', 'onlyForAdult' ];
  dialogRef: any;

  constructor (public dialog: MatDialog,  public snackBar: MatSnackBar,
               public genderFuncService: GenderFuncService) {
  }

  ngOnInit () {
    this.getGenderTypes();
  }

  getGenderTypes () {
    this.genderFuncService.genderTypes().subscribe(res => {
      this.genderTypes = res;
    });
  }

  newType () {
    this.dialogRef = this.dialog.open(GenderTypeDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        const data = response;
        if (response.name) {
          this.genderFuncService.addGenderType(data).subscribe((res) => {
            if (res) {
              this.snackBar.open('Gender type added.', '', {duration: 2500});
              this.getGenderTypes();
            }
          }, error => {
            this.snackBar.open('Add failed.', '', {duration: 2500});
          } );
        }
      });

  }

  editType (type) {
    this.dialogRef = this.dialog.open(GenderTypeDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        type: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        console.log(response);
        const actionType: string = response[ 0 ];
        const data = response[ 1 ];
        data.id = type.id;
        switch (actionType) {
          /**
           * Save
           */
          case 'save':


            this.genderFuncService.addGenderType(data).subscribe((res) => {
              if (res) {
                this.snackBar.open('Gender type updated.', '', {duration: 2500});
                this.getGenderTypes();
              }
            }, error => {
              this.snackBar.open('Update failed.', '', {duration: 2500});
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.genderFuncService.deleteGenderType(type.id).subscribe((res: any) => {
              if (res && !res.error) {
                this.snackBar.open('Organization type deleted.', '', {duration: 2500});
                this.getGenderTypes();
              }
            }, error => {
              this.snackBar.open('Delete failed.', '', {duration: 2500});
            });

            break;
        }
      });
  }
}
